import { SmartPillViewState } from 'owa-mail-reading-pane-store';
import { ClientItem } from 'owa-mail-store';
import { action } from 'satcheljs';

export const setSmartPillBlockVisibility = action(
    'setSmartPillBlockVisibility',
    (viewState: SmartPillViewState, smartPillBlockVisible: boolean) => {
        return {
            viewState: viewState,
            smartPillBlockVisible: smartPillBlockVisible,
        };
    }
);

export const setSmartPillFeedbackSubmitted = action(
    'setSmartPillFeedbackSubmitted',
    (item: ClientItem, smartPillFeedbackSubmitted: boolean) => {
        return {
            item: item,
            smartPillFeedbackSubmitted: smartPillFeedbackSubmitted,
        };
    }
);
